export default {
    role:{
        create: "ADRC",
        read: "ADRR",
        update: "ADRU",
        delete: "ADRD"
    } ,
    user: {
        create: "ADUC",
        read: "ADUR",
        update: "ADUU",
        delete: "ADUD",
        create_role: "ADURO",
        update_role: "ADUURO"
    },
    item: {
        create: "create:item",
        read: "read:item",
        update: "update:item",
        delete: "delete:item",
        index: "index:item"
    },
    measure_unit: {
        create: "create:measureUnit",
        read: "read:measureUnit",
        update: "update:measureUnit",
        delete: "delete:measureUnit",
        index: "index:measureUnit"
    },
    warehouse: {
        create: "create:warehouse",
        read: "read:warehouse",
        update: "update:warehouse",
        delete: "delete:warehouse",
        index: "index:warehouse"
    },
    item_group: {
        create: "create:itemGroup",
        read: "read:itemGroup",
        update: "update:itemGroup",
        delete: "delete:itemGroup",
        index: "index:itemGroup"
    },
    stock_movement: {
        read: "read:stockMovementReport",
    },
    stock_on_hand_item: {
        read: "read:stockByItemReport"
    },
    stock_on_hand_by_warehouse: {
        read: "read:stockByWarehouseReport"
    },
    stock_issued_summary: {
        read: "read:stockIssuedSummary"
    },
    stock_received_summary: {
        read: "read:stockReceivedSummary"
    },
    stock_issued_by_dimension: {
        read: "read:stock_issued_by_dimension"
    },
    warehouse_item: {
        create: "create:warehouseItem",
        read: "read:warehouseItem",
        update: "update:warehouseItem",
        delete: "delete:warehouseItem",
        index: "list:warehouseItem"
    },
    supplier: {
        create: "create:supplier",
        read: "read:supplier",
        update: "update:supplier",
        delete: "delete:supplier",
        index: "list:supplier"
    },
    supplier_contact: {
        create: "create:supplierContact",
        read: "read:supplierContact",
        update: "update:supplierContact",
        delete: "delete:supplierContact"
    },
    supplier_account: {
        create: "create:supplierAccount",
        read: "read:supplierAccount",
        update: "update:supplierAccount",
        delete: "delete:supplierAccount"
    },
    purchase_requisition: {
        create: "create:purchaseRequisition",
        read: "read:purchaseRequisition",
        update: "update:purchaseRequisition",
        delete: "delete:purchaseRequisition",
        index: "list:purchaseRequisition",
        close: "close:purchaseRequisition"
    },
    purchase_order: {
        create: "create:purchaseOrder",
        read: "read:purchaseOrder",
        update: "update:purchaseOrder",
        delete: "delete:purchaseOrder",
        index: "list:purchaseOrder",
        close: "close:purchaseOrder"
    },
    good_receipt: {
        create: "create:goodReceipt",
        read: "read:goodReceipt",
        update: "update:goodReceipt",
        delete: "delete:goodReceipt",
        index: "list:goodReceipt",
        post: "post:goodReceipt"
    },
    good_issue: {
        create: "create:goodIssue",
        read: "read:goodIssue",
        update: "update:goodIssue",
        delete: "delete:goodIssue",
        index: "list:goodIssue",
        post: "post:goodIssue",
        print: "print:goodIssue"
    },
    stock_adjustment: {
        create: "create:stockAdjustment",
        read: "read:stockAdjustment",
        update: "update:stockAdjustment",
        delete: "delete:stockAdjustment",
        index: "list:stockAdjustment",
        post: "post:stockAdjustment"
    },
    po_good_receipt: {
        create: "create:poGoodReceipt",
        read: "read:poGoodReceipt",
        update: "update:poGoodReceipt",
        delete: "delete:poGoodReceipt",
        index: "list:poGoodReceipt",
        post: "post:poGoodReceipt"
    },
    general_receipt: {
        create: "create:generalReceipt",
        read: "read:generalReceipt",
        update: "update:generalReceipt",
        delete: "delete:generalReceipt",
        index: "list:generalReceipt",
        post: "post:generalReceipt"
    },
    credit_note: {
        create: "create:supplierCreditNote",
        read: "read:supplierCreditNote",
        update: "update:supplierCreditNote",
        delete: "delete:supplierCreditNote",
        index: "list:supplierCreditNote",
        post: "post:supplierCreditNote"
    },
    debit_note: {
        create: "create:supplierDebitNote",
        read: "read:supplierDebitNote",
        update: "update:supplierDebitNote",
        delete: "delete:supplierDebitNote",
        index: "list:supplierDebitNote",
        post: "post:supplierDebitNote"
    },
    invoice: {
        create: "create:purchaseInvoice",
        read: "read:purchaseInvoice",
        update: "update:purchaseInvoice",
        delete: "delete:purchaseInvoice",
        index: "list:purchaseInvoice",
        post: "post:purchaseInvoice"
    },
    payment: {
        create: "create:supplierPayment",
        read: "read:supplierPayment",
        update: "update:supplierPayment",
        delete: "delete:supplierPayment",
        index: "list:supplierPayment",
        post: "post:supplierPayment"
    },
    supplier_group: {
        create: "create:supplierGroup",
        read: "read:supplierGroup",
        update: "update:supplierGroup",
        delete: "delete:supplierGroup",
        index: "list:supplierGroup"
    },
    payment_account: {
        create: "create:purchasePaymentModeAccount",
        read: "ADUC",
        update: "ADUC",
        delete: "delete:purchasePaymentModeAccount",
        index: "ADUC"
    },
    report: {
        supplier_account_statement: "read:supplierStatement",
        supplier_account_summary: "read:supplierSummary",
        customers_summary:"read:customersSummary",
        sales_by_item_summary:"SARSBI",
        sales_by_item_details:"read:salesByItemDetails",
        sales_agreements_summary:"SARSOS",
        customer_statement: "SACCS",
        customers_payment_details: "read:customersPaymentDetails",
        customers_collection_details: "read:customerCollectionDetails",
        sales_agreement_validity: "read:salesAgreementValidity",
        unearned_revenue: "read:unearnedRevenue",
        purchase_order_fulfillment: "read:purchaseOrderFulfillment",
        purchase_summary: "read:purchaseSummary",
        purchase_dashboard: "read:purchase_dashboard",
    },
    trial_balance: {
        exportCSV: "export:trialBalance"
    },
    customer: {
        read: "SACR"
    },
    sales_order: {
        read: "SASOR"
    },
    cast_type: {
        read: "SACTR"
    },
    customer_statement: {
        read: "SACCS"
    },
    sales_invoice: {
        read: "SAINROTH"
    },
    payment_collection: {
        read: "SARPC"
    },
    quantity_flow: {
        read: "SARQF"
    },
    sales_credit_note: {
        read: "SACNR"
    },
    sales_debit_note: {
        read: "SADNR"
    },
    quotation: {
        create: "SAQC",
        read: "SAQR",
        update: "SAQU",
        delete: "SAQD"
    },
    casting_report: {
        read: "SACCR"
    },
    sales_scheduling: {
        read: "SASCHR"
    },
    customer_payment: {
        read: "SAPR"
    },
    customer_activities: {
        read: "read:customerActivities"
    },
    good_return: {
        update: "update:goodReturn",
        delete: "delete:goodReturn",
        read: "read:goodReturn",
        create: "create:goodReturn",
        post: "post:goodReturn",
        index: "list:goodReturn"
    },
    driver: {
        create: "create:driver",
        read: "read:driver",
        update: "update:driver",
        delete: "delete:driver",
        index: "list:driver"
    },
    vehicle: {
        create: "create:vehicle",
        read: "read:vehicle",
        update: "update:vehicle",
        delete: "delete:vehicle",
        index: "list:vehicle"
    },
    brand: {
        create: "create:brand",
        read: "read:brand",
        update: "update:brand",
        delete: "delete:brand",
        index: "list:brand"
    },
    model: {
        create: "create:model",
        read: "read:model",
        update: "update:model",
        delete: "delete:model"
    },
    vehicle_usage: {
        create: "create:vehicleUsage",
        read: "read:vehicleUsage",
        update: "update:vehicleUsage",
        delete: "delete:vehicleUsage",
        index: "list:vehicleUsage",
    },
    stock_transfer: {
        create: "create:stockTransfer",
        read: "read:stockTransfer",
        update: "update:stockTransfer",
        delete: "delete:stockTransfer",
        index: "list:stockTransfer",
        print: "print:stockTransfer",
        post: "post:stockTransfer"
    },
    stock_transfer_receipt: {
        create: "create:stockTransferReceipt",
        read: "read:stockTransferReceipt",
        update: "update:stockTransferReceipt",
        delete: "delete:stockTransferReceipt",
        index: "list:stockTransferReceipt",
        print: "print:stockTransferReceipt",
        post: "post:stockTransferReceipt"
    },
    insurance_company: {
        create: "create:insuranceCompany",
        read: "read:insuranceCompany",
        update: "update:insuranceCompany",
        delete: "delete:insuranceCompany",
        index: "list:insuranceCompany",
    },
    vehicle_insurance: {
        create: "create:vehicleInsurance",
        read: "read:vehicleInsurance",
        extend: "extend:vehicleInsurance",
        cancel: "cancel:vehicleInsurance"
    },
    vehicle_license: {
        create: "create:vehicleLicense",
        read: "read:vehicleLicense",
        update: "update:vehicleLicense",
        delete: "delete:vehicleLicense"
    },
    sales_branch: {
        create: "create:salesBranch",
        read: "read:salesBranch",
        update: "update:salesBranch",
        delete: "delete:salesBranch",
        index: "list:salesBranch",
    },
    sales_person: {
        create: "create:salesPerson",
        read: "read:salesPerson",
        update: "update:salesPerson",
        delete: "delete:salesPerson",
        index: "list:salesPerson",
    },
    sales_dashboard: {
        all: "read:salesDashboard"
    },
    landed_cost_component: {
        create: "create:landedCostComponent",
        read: "read:landedCostComponent",
        update: "update:landedCostComponent",
        delete: "delete:landedCostComponent",
        index: "create:landedCostComponent",
    },
    landed_cost: {
        create: "create:landedCost",
        read: "read:landedCost",
        update: "update:landedCost",
        delete: "delete:landedCost",
        index: "list:landedCost",
        post: "post:landedCost",
        print: "print:landedCost"
    },
    period: {
        closing: "period:closing",
    }
};